export const CIVILPROGRESSION_LOADING = "CIVILPROGRESSION_LOADING";
export const CIVILPROGRESSION_RESET = "CIVILPROGRESSION_RESET";
export const GET_CIVILPROGRESSION = "GET_CIVILPROGRESSION";
export const GET_CIVILPROGRESSION_SUCCESS = "GET_CIVILPROGRESSION_SUCCESS";
export const GET_CIVILPROGRESSION_FAIL = "GET_CIVILPROGRESSION_FAIL";
export const DELETE_CIVILPROGRESSION = "DELETE_CIVILPROGRESSION"
export const DELETE_CIVILPROGRESSION_SUCCESS = "DELETE_CIVILPROGRESSION_SUCCESS"
export const DELETE_CIVILPROGRESSION_FAIL = "DELETE_CIVILPROGRESSION_FAIL"
export const UPDATE_CIVILPROGRESSION = "UPDATE_CIVILPROGRESSION"
export const UPDATE_CIVILPROGRESSION_SUCCESS = "UPDATE_CIVILPROGRESSION_SUCCESS"
export const UPDATE_CIVILPROGRESSION_FAIL = "UPDATE_CIVILPROGRESSION_FAIL"
export const ADD_NEW_CIVILPROGRESSION = "ADD_NEW_CIVILPROGRESSION"
export const ADD_CIVILPROGRESSION_SUCCESS = "ADD_CIVILPROGRESSION_SUCCESS"
export const ADD_CIVILPROGRESSION_FAIL = "ADD_CIVILPROGRESSION_FAIL"